// Material Kit 2 React components
import MKBox from "components/MKBox";
import { collection, getDocs, limit, orderBy, query } from "firebase/firestore";
import { database } from "../../../firebase";
import { useEffect, useState } from "react";
import MKTypography from "components/MKTypography";
import ScrollReveal from "components/ScrollReveal";
import { CircularProgress } from "@mui/material";

function NoticiasFetch() {
  const [noticias, setNoticias] = useState([]);
  const [loading, setLoading] = useState(false);

  const getNoticias = async (page) => {
    setLoading(true);
    try {
      let initialQuery = query(
        collection(database, "noticias"),
        orderBy("fecha", "desc"),
        limit(20)
      );

      const documentSnapshots = await getDocs(initialQuery);
      const noticiasData = documentSnapshots.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

      setNoticias(noticiasData);
      // Update the lastVisible to the last document in the current query
    } catch (error) {
      console.error("Error fetching documents:", error);
    } finally {
      setLoading(false);
    }
  };
  const renderDate = (fecha) => {
    if (fecha) {
      const milliseconds = fecha.seconds * 1000;
      const date = new Date(milliseconds);

      const getMonthName = (month) => {
        const monthNames = [
          "enero",
          "febrero",
          "marzo",
          "abril",
          "mayo",
          "junio",
          "julio",
          "agosto",
          "septiembre",
          "octubre",
          "noviembre",
          "diciembre",
        ];
        return monthNames[month];
      };

      const day = date.getDate();
      const month = getMonthName(date.getMonth());
      const year = date.getFullYear();

      const formattedDate = `${day} de ${month} de ${year}`;

      return formattedDate;
    } else {
      return "-";
    }
  };
  useEffect(() => {
    getNoticias();
  }, []);
  return (
    <MKBox component="section" py={{ xs: 5, md: 7 }}>
      <ScrollReveal>
        <MKBox textAlign="center">
          <MKTypography
            variant="h1"
            fontWeight="bold"
            color="primary"
            sx={{ fontSize: { xs: "2.35rem", md: "3.25rem" } }}
          >
            Novedades
          </MKTypography>
        </MKBox>
      </ScrollReveal>
      {loading ? (
        <MKBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            height: "40vh",
          }}
        >
          <CircularProgress size={100} />
        </MKBox>
      ) : noticias.length > 0 ? (
        <MKBox display="flex" flexDirection="column" alignItems="center" justifyContent="center">
          {noticias.map((noticia, index) => (
            <ScrollReveal
              key={index}
              delay={(index % 3) * 90}
              sx={{ width: { xs: "100%", sm: "88%", md: "72%" } }}
            >
              <MKBox
                className="school-news-card"
                my={{ xs: 4, md: 5 }}
                sx={{
                  background:
                    "linear-gradient(145deg, rgba(255,255,255,0.92), rgba(255,249,240,0.82))",
                  border: "1px solid rgba(62, 161, 236, 0.16)",
                  borderRadius: "24px",
                  boxShadow: "0 20px 58px rgba(24, 34, 54, 0.1)",
                  overflow: "hidden",
                  "& ul": {
                    listStylePosition: "inside",
                  },
                  "& img": {
                    borderRadius: "18px",
                  },
                }}
              >
                <MKBox px={{ xs: 2.5, md: 3 }} pt={{ xs: 2.5, md: 3 }}>
                  <MKTypography variant="button" fontWeight="bold" color="primary">
                    {renderDate(noticia.fecha)}
                  </MKTypography>
                </MKBox>
                {/* <MKTypography variant="h2" fontWeight="bold">
                {noticia.titulo}
              </MKTypography> */}
                <MKBox
                  p={{ xs: 2.5, md: 3 }}
                  dangerouslySetInnerHTML={{
                    __html: `<div style="list-style-position: inside;">${noticia.contenido}</div>`,
                  }}
                />
              </MKBox>
            </ScrollReveal>
          ))}
          {/* <MKBox
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              borderRadius: "10px",
              border: "1px solid black",
            }}
            p={1}
          >
            <MKTypography
              variant="h5"
              fontWeight="bold"
              color="primary"
              sx={{
                cursor: "pointer",
                "&:hover": {
                  color: "secondary",
                },
              }}
              component={Link}
              to="/noticias"
            >
              Ver mas novedades &nbsp;
              <Icon>redo</Icon>
            </MKTypography>
          </MKBox> */}
        </MKBox>
      ) : (
        <MKBox display="flex" justifyContent="center">
          <MKTypography variant="h6" fontWeight="medium" color="secondary">
            Por el momento no hay novedades.
          </MKTypography>
        </MKBox>
      )}
    </MKBox>
  );
}

export default NoticiasFetch;
